import { TOS_VERSION } from "@rua-watch/shared";
import { ThemeToggle } from "../../components/theme";

// Public legal pages (Terms of Service, Privacy Policy). Rendered ABOVE the
// auth gate (see main.tsx isLegalPath) so they're reachable with or without a
// session and never depend on Auth0/tenant state. Stub copy — the Etus legal
// team replaces the body text; bump TOS_VERSION in @rua-watch/shared when it
// changes so signup consent stays auditable.
//
// Navigation in/out uses plain <a href> (full reload) on purpose: that lets the
// top-level legal check in main.tsx intercept the path regardless of auth,
// keeping these pages out of the authenticated router.

function LegalLayout({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-800 dark:bg-slate-950 dark:text-slate-200">
      <header className="border-b border-slate-200 dark:border-slate-800">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
          <a href="/" className="flex items-center gap-2">
            <img src="/etus-logo.png" alt="Etus" className="h-8 w-8 rounded-lg shadow-sm" />
            <span className="font-semibold text-slate-900 dark:text-slate-100">Etus DMARC Monitor</span>
          </a>
          <ThemeToggle />
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-10">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-100">{title}</h1>
        <p className="mt-1 text-xs text-slate-500">Versão {TOS_VERSION}</p>
        <div className="prose prose-slate mt-6 max-w-none text-sm leading-relaxed dark:prose-invert">
          {children}
        </div>
        <div className="mt-10 flex gap-4 text-sm text-slate-500">
          <a href="/terms" className="hover:text-slate-700 dark:hover:text-slate-300">Termos</a>
          <a href="/privacy" className="hover:text-slate-700 dark:hover:text-slate-300">Privacidade</a>
          <a href="/" className="hover:text-slate-700 dark:hover:text-slate-300">Início</a>
        </div>
      </main>
    </div>
  );
}

// Placeholder paragraphs until the legal team supplies the real copy.
function Placeholder() {
  return (
    <>
      <p className="text-amber-700 dark:text-amber-300">
        <strong>Rascunho.</strong> Este texto é um placeholder e será substituído pela versão
        oficial do jurídico da Etus antes da abertura pública do cadastro.
      </p>
      <p>
        Este documento descreve as condições de uso do Etus DMARC Monitor. Ao criar uma conta,
        o usuário concorda com o monitoramento de relatórios DMARC agregados dos domínios que
        cadastrar e com o tratamento de dados conforme descrito na Política de Privacidade.
      </p>
      <p>
        Os relatórios DMARC podem conter endereços IP de origem, tratados como dado potencialmente
        pessoal sob a LGPD. Aplicamos retenção por plano e o titular pode solicitar a exclusão da
        workspace a qualquer momento.
      </p>
    </>
  );
}

export function TermsPage() {
  return (
    <LegalLayout title="Termos de Serviço">
      <Placeholder />
    </LegalLayout>
  );
}

export function PrivacyPage() {
  return (
    <LegalLayout title="Política de Privacidade">
      <Placeholder />
    </LegalLayout>
  );
}
